{
	"meni": {
		"title": "Meni"
	},
	"uporabnik": {
		"odjava": "odjava"
	},
	"pregled": {
		"title": "Pregled površin",
		"description": "Poročilo o pregledu površin"
	},
	"dnevniRazpored": {
		"title": "Dnevni razpored letenja",
		"description": "Dodaj / beri dnevni razpored letenja"
	},
	"startnaListaJ": {
		"title": "Štartna lista (Jadralni)",
		"description": "Dodaj zapis za jadralno letalo"
	},
	"startnaListaM": {
		"title": "Štartna lista (Motorni)",
		"description": "Dodaj zapis za motorno letalo"
	},
	"startnaListaUL": {
	  "title": "Štartna lista (UltraLight)",
	  "description": "Dodaj zapis za ultralight letalo"
	},
	"obracuni": {
		"title": "Obračuni",
		"description": "Pregled zapisov"
	},
	"porocila": {
		"title": "Poročila in statistika",
		"description": "Pregled letov, ur in aktivnost"
	},
	"log": {
		"title": "Dnevnik brisanja / urejanja",
		"description": "Pregled brisanih in urejenih zapisov"
	},
	"dnevnikPilotov": {
		"title": "Dnevnik pilotov (motorni)",
		"description": "Vnos in pregled osebne knjižice"
	},
	"dnevnikPilotovJ": {
		"title": "Dnevnik pilotov (jadralni)",
		"description": "Pilotova osebna knjižica za jadralne lete"
	},
	"nalogLet": {
		"title": "Nalog za let",
		"description": "Kreiraj in pošlji nalog za let"
	},
	"dokumentacijaNalogov": {
		"title": "Dokumentacija nalogov",
		"description": "Potrdi / Zavrni nalog za let"
	},
	"sifrantiP": {
		"title": "Piloti",
		"description": "Šifrant pilotov"
	},
	"sifrantiL": {
		"title": "Letala",
		"description": "Dodaj šifrant za letala"
	},
	"sifrantiK": {
		"title": "Klubi",
		"description": "Šifrant klubov"
	},
	"nastavitveLeta": {
		"title": "Nastavitve letenja",
		"description": "Šolski krogi, Nastavitve 'current' pogojev,..."
	},	
	"nastavitveIzpisov": {
		"title": "Nastavitve izpisov",
		"description": "Nastavitev žiga, Nastavitev logotipa, Nastavitev glave za izpise,..."
	},
	"nastavitve": {
		"title": "Nastavitve Admin",
		"description": "Nastavitve programa"
	},
	"pregledDostopov": {
		"title": "Pregled dostopov",
		"description": "Pregled dostopov do aplikacije"
	},
	"patchNotes": {
		"title": "Patch notes",
		"description": "Dodaj / Zamenjaj patch notes"
	},
	"praviceUporabnikov": {
		"title": "Nastavitev pravic",
		"description": "Nastavitev pravic (urejanje, brisanje) uporabnika"
	},
	"deaktivacijaUporabnikov": {
		"title": "Deaktivirani uporabniki",
		"description": "Upravljanje deaktiviranih računov"
	},
	"hr": {
		"dnevniki": "Dnevniki",
		"dokumenti": "Dokumenti",
		"sifranti": "Šifranti",
		"nastavitveLeta": "Nastavitve leta / Izpisov",
		"administracija": "Administracija",
		"pravice": "Pravice uporabnikov",
		"upravitelj": "Upraviteljske nastavitve",
		"briefing": "Briefing"
	},
	"availability": {
	    "title": "Razpoložljivost",
	    "description": "Sporočanje razpoložljivosti" 
	},
	"camo": {
		"title": "Camo",
		"description": "Camo vzdrževanje"
	},
	"camo_log": {
		"title": "Camo Log-i",
		"description": "Pregled izpisov CAMO"
	},
	"upravitelj": {
		"title": "Upravitelj - nastavitve",
		"description": "Upraviteljske nastavitve. Naziv upravitelja, camo, nastavitve pregledov,..."
	},
	"wb":{
		"title": "Masa in težišče (W&B)",
		"description": "Kalkulacija mase in težišča (W & B)"
	}
}